import LightBoxService from '../../components/lightbox/lightbox.service'

const lightboxService = new LightBoxService()

const state = lightboxService.getLightBoxConfigData()

const getters = {

  lightBoxloaderOn (state) {
    return state.lightbox.isLightBoxLoaderOn
  },

  isRecognized (state) {
    if (state.lightbox.recognized) {
      return state.lightbox.recognized
    }
    return false
  },

  consumerAuthorization (state) {
    return state.lightbox.consumerAuthorization || null
  },

  sortedCards (state) {
    return state.lightbox.sortedCards || null
  },

  validationData (state) {
    return state.lightbox.validationData || null
  },

  isError (state) {
    return state.lightbox.isError || false
  },

  dpaTransactionOptions (state) {
    return state.lightbox.dpaTransactionOptions || null
  },

  identityFoundAt (state) {
    return state.lightbox.identityFoundAt || null
  },

  storeSuccessMsg (state) {
    return state.lightbox.storeSuccessMsg || null
  },

  srciActionCode (state) {
    return state.lightbox.srciActionCode || null
  },

  isIdentityTypeMobile (state) {
    return state.lightbox.isIdentityTypeMobile || false
  },

  checkoutProgress (state) {
    return state.lightbox.checkoutProgress || false
  }
}

const actions = {
  recognized ({ commit }, recognized) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('recognized', recognized)
        resolve()
      }, 100)
    })
  },

  consumerAuthorization ({ commit }, { idToken }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('consumerAuthorization', { idToken })
        resolve()
      }, 100)
    })
  },

  validationData ({ commit }, { result }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('validationData', { result })
        resolve()
      }, 100)
    })
  },

  isError ({ commit }, hasError) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('isError', hasError)
        resolve()
      }, 100)
    })
  },

  dpaTransactionOptions ({ commit }, dpaTransactionOptions) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('dpaTransactionOptions', dpaTransactionOptions)
        resolve()
      }, 100)
    })
  },

  updateSortedCards ({ commit }, sortedCards) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('commitSortedCards', sortedCards)
        resolve()
      }, 100)
    })
  },

  identityFoundAt ({ commit }, result) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('identityFoundAt', result)
        resolve()
      }, 100)
    })
  },

  lightBoxloaderOn ({ commit }, isLoading) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('lightBoxloaderOn', isLoading)
        resolve()
      }, 100)
    })
  },

  storeSuccessMsg ({ commit }, { result }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('storeSuccessMsg', { result })
        resolve()
      }, 100)
    })
  },

  srciActionCode ({ commit }, { result }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('srciActionCode', { result })
        resolve()
      }, 100)
    })
  },

  checkoutProgress ({ commit }, result) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('checkoutProgress', result)
        resolve()
      }, 100)
    })
  },

  isIdentityTypeMobile ({ commit }, { result }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('isIdentityTypeMobile', { result })
        resolve()
      }, 100)
    })
  }

}

const mutations = {

  resetLightbox () {
    lightboxService.setInitialConfiguration()
  },

  recognized (state, recognized) {
    state.lightbox.recognized = recognized
    lightboxService.setLightBoxConfigData(state)
  },

  consumerAuthorization (state, idToken) {
    state.lightbox.consumerAuthorization = idToken
    lightboxService.setLightBoxConfigData(state)
  },

  validationData (state, result) {
    state.lightbox.validationData = result
    lightboxService.setLightBoxConfigData(state)
  },

  isError (state, hasError) {
    state.lightbox.isError = hasError
  },

  dpaTransactionOptions (state, dpaTransactionOptions) {
    state.lightbox.dpaTransactionOptions = dpaTransactionOptions
  },

  commitSortedCards (state, result) {
    state.lightbox.sortedCards = result
    lightboxService.setLightBoxConfigData(state)
  },

  identityFoundAt (state, result) {
    state.lightbox.identityFoundAt = result
    lightboxService.setLightBoxConfigData(state)
  },

  lightBoxloaderOn (state, isLoading) {
    state.lightbox.isLightBoxLoaderOn = isLoading
    lightboxService.setLightBoxConfigData(state)
  },

  storeSuccessMsg (state, result) {
    state.lightbox.storeSuccessMsg = result
    lightboxService.setLightBoxConfigData(state)
  },

  srciActionCode (state, result) {
    state.lightbox.srciActionCode = result
    lightboxService.setLightBoxConfigData(state)
  },

  checkoutProgress (state, result) {
    state.lightbox.checkoutProgress = result
    lightboxService.setLightBoxConfigData(state)
  },

  isIdentityTypeMobile (state, result) {
    state.lightbox.isIdentityTypeMobile = result
    lightboxService.setLightBoxConfigData(state)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
